export function initContactForms() {
  const forms = document.querySelectorAll('[data-contact-form]');

  forms.forEach((form) => {
    const status = form.querySelector('[data-contact-form-status]');
    const submitButton = form.querySelector('button[type="submit"]');

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!window.coolairData) {
        return;
      }

      setStatus(status, '', '');
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');

      const formData = new FormData(form);
      formData.append('action', 'coolair_contact_form');

      try {
        const response = await fetch(window.coolairData.ajaxUrl, {
          method: 'POST',
          body: formData,
          credentials: 'same-origin',
        });

        const result = await response.json();

        if (result.success) {
          setStatus(status, result.data.message, 'success');
          form.reset();
        } else {
          setStatus(status, result.data?.message || 'Coś poszło nie tak. Spróbuj ponownie.', 'error');
        }
      } catch (error) {
        setStatus(status, 'Coś poszło nie tak. Spróbuj ponownie.', 'error');
      } finally {
        submitButton.disabled = false;
        submitButton.classList.remove('is-loading');
      }
    });
  });
}

function setStatus(el, message, type) {
  if (!el) return;
  el.textContent = message;
  el.classList.remove('is-success', 'is-error');
  if (type) el.classList.add(`is-${type}`);
}
